import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo, useMemo } from "react";
import { useCurrentOrganizationMembers } from "@api/organizationMember.api";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { UserAvatar } from "@components/avatar/UserAvatar";
import { HStack } from "@design-system/HStack/HStack";
import { CloseTemplateRow } from "../organizationCloseTemplatesViewConfig";

export const CloseTemplateUpdatedByCell = memo(
    ({ row }: CellContext<ViewTableFeatures, CloseTemplateRow, unknown>) => {
        const { data: members = [] } = useCurrentOrganizationMembers();
        const updatedBy = useMemo(
            () =>
                row.original.updatedByUserId != null
                    ? (members.find(
                          (m) => m.user.id === row.original.updatedByUserId,
                      ) ?? null)
                    : null,
            [row.original.updatedByUserId, members],
        );

        return (
            <ViewTableCell>
                {updatedBy ? (
                    <HStack gap={8} align="center">
                        <UserAvatar
                            user={updatedBy.user}
                            size="sm"
                            aria-hidden
                        />
                        {updatedBy.user.name}
                    </HStack>
                ) : (
                    <span className="text-muted">-</span>
                )}
            </ViewTableCell>
        );
    },
);
